import { Controller } from "@hotwired/stimulus"
import { FormHelper } from "~/helpers/form_helper"

export default class extends Controller {
  // Hides the modal on a successful form submission (as long as there is no error status)
  // action: "turbo:submit-end->subscription--modal#submitEnd"
  submitEnd(e) {
    if (e.detail.success) {
      const modal = bootstrap.Modal.getOrCreateInstance(this.element)
      modal.hide()
    }
  }

  notAuthorized() {
    FormHelper.displayFlashError(i18n.t("js.front.errors.not_team_owner"))
  }
}
